import React from 'react'
import {
  Columns,
  Icon,
  SegControl,
  Stack,
  Text,
} from '@lightspeed/design-system-react'

import { T } from '@transifex/react'
import { FulfilmentType } from '../../../../../../models/fulfilment'

interface FulfilmentSelectProps {
  title?: string
  onTypeChange: (type: FulfilmentType) => void
  defaultType?: string
  showUnspecified?: boolean
  message?: string
  disabled?: boolean
  stretched?: boolean
}

export const FulfilmentSelect: React.FC<FulfilmentSelectProps> = ({
  title,
  defaultType,
  onTypeChange,
  showUnspecified,
  message,
  disabled,
  stretched,
}) => {
  return (
    <Stack space={2}>
      <Text type="label">
        {title || <T _str="Fulfillment method" _context="Fulfilment select" />}
      </Text>
      <div
        className="vd-flex"
        onClick={event => {
          // Prevent closing the Line Item Fulfilment Popover
          event.stopPropagation()
        }}
      >
        {showUnspecified && (
          <SegControl
            name="fulfilType"
            role="radio"
            stretched={stretched}
            disabled={defaultType !== FulfilmentType.UNSPECIFIED && disabled}
            checked={defaultType === FulfilmentType.UNSPECIFIED}
            onChange={() => onTypeChange(FulfilmentType.UNSPECIFIED)}
            data-track="unspecified-fulfilment"
          >
            <T _str="None" _context="Fulfilment select" />
          </SegControl>
        )}
        <SegControl
          name="fulfilType"
          role="radio"
          stretched={stretched}
          disabled={defaultType !== FulfilmentType.DELIVERY && disabled}
          checked={defaultType === FulfilmentType.DELIVERY}
          onChange={() => onTypeChange(FulfilmentType.DELIVERY)}
          data-track="delivery-fulfilment"
        >
          <T _str="Delivery" _context="Fulfilment select" />
        </SegControl>
        <SegControl
          name="fulfilType"
          role="radio"
          stretched={stretched}
          disabled={defaultType !== FulfilmentType.PICKUP && disabled}
          checked={defaultType === FulfilmentType.PICKUP}
          onChange={() => onTypeChange(FulfilmentType.PICKUP)}
          data-track="pickup-fulfilment"
        >
          <T _str="Pickup" _context="Fulfilment select" />
        </SegControl>
      </div>
      {message && (
        <Columns space={2}>
          <Text type="supplementary">
            <Icon icon="fa-info-circle" />
          </Text>
          <Text role="textbox" type="supplementary">
            {message}
          </Text>
        </Columns>
      )}
    </Stack>
  )
}

FulfilmentSelect.displayName = 'FulfilmentSelect'
